import React from 'react';
import Chart from "react-google-charts";
import { useEffect, useState } from 'react';

import Loader from '../Utils/Loader';
import ListGraphicFilters from './ListGraphicFilters';
import imgNoResultsDark from '../../img/dark-theme/empty-state.svg'

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postCollectInstallationAnalytics = endpointHelias+'/Helias/V0/Analytics/postCollectInstallationAnalytics';	

var initialConfigCommonJS = require("../../js/initialConfigCommon.js")
var analyticsCommonJS = require("../../js/analyticsCommon.js")
var generalCommonJS = require("../../js/generalCommon.js")
var dashbardCommonJS = require("../../js/dashboardCommon.js")

var etiquetas = [];
var filas = [];
var chartObj = ""
var googleObj = ""
var estadoVisibilidadLineasGráfica = []
var datosProcesados = [["A","B"],[0,1]]
var columns = []

var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds

const GoogleChartGraphics = (params) => {
    
    // Para poder revertir al color original al mostrar / ocultar líneas
    var backupColoresGrafica = {    
        0: { color: '#3498DB' }, 
        1: { color: '#F5B041' },
        2: { color: '#5EC264' }, 
        3: { color: '#D65DB1' }, 
        4: { color: '#FF6F91' }, 
        5: { color: '#FF9671' }, 
        6: { color: '#845EC2' }, 
        7: { color: '#008F7A' }, 
        8: { color: '#FF8066' }, 
        9: { color: '#008E9B' }, 
        10: { color: '#EE82EE' }, 
        11: { color: '#FF4500' }, 
        12: { color: '#6495ED' }, 
        13: { color: '#483D8B' }, 
        14: { color: '#191970' }, 
        15: { color: '#FFF8DC' }, 
        16: { color: '#00FFFF' }, 
        17: { color: '#9932CC' }, 
        18: { color: '#BDB76B' }, 
        19: { color: '#000080' }, 
        20: { color: '#FFFACD' }, 
        21: { color: '#FAF0E6' }, 
        22: { color: '#D2691E' }, 
        23: { color: '#CD5C5C' }, 
        24: { color: '#2E8B57' }, 
        25: { color: '#778899' }, 
        26: { color: '#3CB371' }, 
        27: { color: '#FFDEAD' }, 
        28: { color: '#66CDAA' }, 
        29: { color: '#FFFAF0' }, 
        30: { color: '#8B0000' }, 
        31: { color: '#4682B4' }, 
        32: { color: '#F5FFFA' }, 
        33: { color: '#F0FFF0' }, 
        34: { color: '#7CFC00' }, 
        35: { color: '#FF00FF' }, 
        36: { color: '#FF8C00' }, 
        37: { color: '#87CEEB' }, 
        38: { color: '#F0F8FF' }, 
        39: { color: '#DA70D6' }, 
        40: { color: '#DCDCDC' }, 
        41: { color: '#BC8F8F' }, 
        42: { color: '#BA55D3' }, 
        43: { color: '#FFE4E1' }, 
        44: { color: '#FFFFF0' }, 
        45: { color: '#8B4513' }, 
        46: { color: '#F8F8FF' }, 
        47: { color: '#F5F5F5' }, 
        48: { color: '#ADFF2F' }, 
        49: { color: '#32CD32' }, 
        50: { color: '#00FFFF' }, 
        51: { color: '#C71585' }, 
        52: { color: '#D8BFD8' }, 
        53: { color: '#EEE8AA' }, 
        54: { color: '#FDF5E6' }, 
        55: { color: '#DDA0DD' }, 
        56: { color: '#FF6347' }, 
        57: { color: '#4B0082' }, 
        58: { color: '#7FFF00' }, 
        59: { color: '#A9A9A9' }, 
        60: { color: '#FFE4B5' }, 
        61: { color: '#008000' }, 
        62: { color: '#6A5ACD' }, 
        63: { color: '#FA8072' }, 
        64: { color: '#00FA9A' }, 
        65: { color: '#008B8B' }, 
        66: { color: '#8B008B' }, 
        67: { color: '#CD853F' }, 
        68: { color: '#DC143C' }, 
        69: { color: '#FF0000' }, 
        70: { color: '#F0E68C' }, 
        71: { color: '#48D1CC' }, 
        72: { color: '#40E0D0' }, 
        73: { color: '#90EE90' }, 
        74: { color: '#FFF5EE' }, 
        75: { color: '#FF69B4' }, 
        76: { color: '#F0FFFF' }, 
        77: { color: '#7B68EE' }, 
        78: { color: '#C0C0C0' }, 
        79: { color: '#000000' }, 
        80: { color: '#ADD8E6' }, 
        81: { color: '#228B22' }, 
        82: { color: '#D3D3D3' }, 
        83: { color: '#E9967A' }, 
        84: { color: '#F4A460' }, 
        85: { color: '#696969' }, 
        86: { color: '#F08080' }, 
        87: { color: '#FFFFFF' }, 
        88: { color: '#00CED1' }, 
        89: { color: '#00FF7F' }, 
        90: { color: '#808080' }, 
        91: { color: '#008080' }, 
        92: { color: '#A0522D' }, 
        93: { color: '#FFF0F5' }, 
        94: { color: '#87CEFA' }, 
        95: { color: '#9400D3' }, 
        96: { color: '#FFFF00' }, 
        97: { color: '#4169E1' }, 
        98: { color: '#5F9EA0' }, 
        99: { color: '#B8860B' }               
    } 

    var options = {                       
        region: '002',                     
        backgroundColor: { fill:'transparent',fillOpacity: 0 },
        datalessRegionColor: '#F5F5F5',
        defaultColor: '#778ba5',
        chartArea:{left:62,top:10, bottom:obtenerAlturaEtiquetaHAxis(), right:20, width:"100%",height:"100%"},
        curveType: 'function',
        lineWidth: 2,
        pointSize: 8,
        pointsVisible:false,          
        hAxis: {                                                                                                  
            textStyle:{fontName: 'hAxisAnalytics'},
            showTextEvery: obtenerEspaciadoGrafica()            
        }, 
        vAxis: {
            textStyle:{fontName: 'vAxis'},
            baselineColor: 'none',
            minorGridlines: {color: 'transparent'},
            viewWindowMode:"explicit",
            viewWindow: obtenerTamañoGrafica()
        },          
        xAxis: {
            textPosition: 'none',
            type: 'datetime',
            baselineColor:"transparent"
        },                  
        tooltip:{
            isHtml: true
        },                        
        animation:{
            startup: false,
            duration: 500,
            easing: 'inAndOut',
        },
        series: { ...backupColoresGrafica } 
        
    }

    useEffect(() => {                

        cargarDatosGraficas()                   
        console.log("Gráfica cargada / actualizada")     

        if(document.getElementById("pestañaAnalyticsPersonalizado").checked === true){
            document.getElementById("etiquetaFechaNoEditable").className = document.getElementById("etiquetaFechaNoEditable").className.replaceAll(" hidden", "") + " hidden"                                      
            document.getElementById("divEtiquetaFechaEditable").className = document.getElementById("divEtiquetaFechaEditable").className.replaceAll(" hidden", "")
        }
        else{
            document.getElementById("etiquetaFechaNoEditable").className = document.getElementById("etiquetaFechaNoEditable").className.replaceAll(" hidden", "")                                        
            document.getElementById("divEtiquetaFechaEditable").className = document.getElementById("divEtiquetaFechaEditable").className.replaceAll(" hidden", "") + " hidden"
        }

    },[params.objQueryGrafica]);

    const [objEtiquetas, setObjEtiquetas] = useState([])

    const chartEvents = [
    {
        eventName: "ready",
        callback: ({ chartWrapper, google }) => {
            chartObj = chartWrapper.getChart()
            googleObj = google            
        }
    }
    ];

    function inicializarElementosVisualesGráfica(){
        estadoVisibilidadLineasGráfica = []   
        options.series = { ...backupColoresGrafica } 
        columns = []

        for(var x=0; x < etiquetas.length; x++){
            if(document.getElementById("Etiqueta"+x) !== null){
                document.getElementById("Etiqueta"+x).style = 'color: '+backupColoresGrafica[x-1].color
                document.getElementById("Etiqueta"+x).className = document.getElementById("Etiqueta"+x).className.replace("secondary", "tertiary")                 
            }
        }

        setObjEtiquetas(etiquetas)    
    }

    function showHideSeries(chart,google,item) {

        if(estadoVisibilidadLineasGráfica.length === 0){
            for(var x = 0; x < etiquetas.length; x++){
                estadoVisibilidadLineasGráfica.push("on")
            }
        }

        var data = new google.visualization.DataTable();    
        
        for (var i = 0; i < etiquetas.length; i++) {
            if(etiquetas[i] === "DATETIME"){			
                data.addColumn('string', etiquetas[i]);
            }
            else{
                data.addColumn('number', etiquetas[i]);
            }
        }
    
        data.addRows(filas);
            
        var sel = item   
        
        if(columns.length === 0){
            columns = etiquetas.map((x) => x);
        }        
                        
        if (sel.length > 0) {
            
            // if row is undefined, we clicked on the legend
            if (sel[0].row === null) {      
                var col = sel[0].column;                
                var estadoFiltroTrasAccion = 0

                if(estadoVisibilidadLineasGráfica[col] === "on"){
                    estadoFiltroTrasAccion = 1
                }

                var numeroFiltrosSeleccionados = estadoVisibilidadLineasGráfica.filter(x => x==="on").length - estadoFiltroTrasAccion
        
                if( numeroFiltrosSeleccionados < 2){
                    initialConfigCommonJS.mostrarMensajeInformativo("¿En serio quieres una gráfica vacía? Debe haber al menos un valor seleccionado.","info")                    
                }
                else{
                
                    if (estadoVisibilidadLineasGráfica[col] === "on") {                                 
                        // hide the data series
                        columns[col] = {
                            label: columns[col],
                            type: data.getColumnType(col),                        
                            calc: function () {
                                return null;
                            }
                        };    
                        // grey out the legend entry                        
                        options.series[col-1] = {color: '#CCCCCC'} 
                        estadoVisibilidadLineasGráfica[col] = "off"
                        document.getElementById("Etiqueta"+col).style = ' color: #CCCCCC;background-color:rgba(0, 0, 0, 0.0);'
                        document.getElementById("Etiqueta"+col).className = document.getElementById("Etiqueta"+col).className.replace("tertiary", "secondary")         
                    }
                    else {                        
                        // show the data series                    
                        options.series[col-1] = backupColoresGrafica[col-1];                
                        columns[col] =  col
                        estadoVisibilidadLineasGráfica[col] = "on"             
                        document.getElementById("Etiqueta"+col).style = 'color: '+backupColoresGrafica[col-1].color
                        document.getElementById("Etiqueta"+col).className = document.getElementById("Etiqueta"+col).className.replace("secondary", "tertiary")                    
                    }

                    var view = new google.visualization.DataView(data);    
                    view.setColumns(columns);            
                    chart.draw(view, options);

                }                
            }
        }            
    }

    function cargarDatosGraficas(){

        if(params.objQueryGrafica === undefined){
            params.objQueryGrafica = {"fromDatetime": (new Date(Date.now() - tzoffset)).toISOString().substring(0,19),"toDatetime": (new Date(Date.now() - tzoffset)).toISOString().substring(0,19),"queryFilters":""}
        }

        var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
        var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        
        
        document.getElementById("loader"+params.graphicId).className = "loader contextual"                

        var idInstalacion = ""

        if(localStorage.getItem("activeUserInstallation") !== null){ //Está consultando un instalador
            idInstalacion = localStorage.getItem("activeUserInstallation")
        }
        else{ //Está consultando un usuario
            idInstalacion = localStorage.getItem("installationId")
        }

        //Petición de datos para el paso actual    
        var jsonPeticion = {
            "accountID": localStorage.getItem("accountID"),
            "installationID": idInstalacion,
            "datetimeFrom": params.objQueryGrafica.fromDatetime,
            "datetimeTo": params.objQueryGrafica.toDatetime,
            "filters": params.objQueryGrafica.queryFilters
        }
        
        if(params.objQueryGrafica.queryFilters !== ""){
            // Guardo la información  
            var xhttp = new XMLHttpRequest();  
                xhttp.open("POST", postCollectInstallationAnalytics, true);        
                xhttp.setRequestHeader('Content-Type', "application/json");
                xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
                var data = JSON.stringify(jsonPeticion);
                xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var jsonRespuesta = JSON.parse(this.responseText)
            
                    if(jsonRespuesta.statusCode === "403"){                   
                        initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
                    }
                    else if(jsonRespuesta.statusCode === "500"){                   
                        initialConfigCommonJS.mostrarMensajeInformativo("Se ha producido un error, vuelve a intentarlo en unos minutos.","negative")
                    }
                    else{          
                        //Si recibo datos ya configurados lo cargo  

                        if(typeof jsonRespuesta.body !== 'undefined'){

                            if(jsonRespuesta.body.length > 0){   
                                
                                if(params.objQueryGrafica.queryFilters.includes("PowerContracted")){

                                    var potenciaContratada = JSON.parse(localStorage.getItem("lastDashboardData")).InstallationData.GeneralInfo.PowerContracted

                                    for(var x=0; x < jsonRespuesta.body.length; x++){

                                        if(jsonRespuesta.body[x].PowerContracted === undefined){
                                            jsonRespuesta.body[x].PowerContracted = potenciaContratada
                                        }

                                    }

                                }                                
                                
                                document.getElementById(params.graphicId).className = document.getElementById(params.graphicId).className.replaceAll(" hidden", "")                                                                
                                document.getElementById("mensajeNoHayDatosGrafica"+params.graphicId).className = document.getElementById("mensajeNoHayDatosGrafica"+params.graphicId).className.replaceAll(" hidden", "") + " hidden"
                                
                                datosProcesados = procesarDatosGrafica(jsonRespuesta.body)                                      
                                inicializarElementosVisualesGráfica()

                                analyticsCommonJS.setearFiltradoActual(params.objQueryGrafica.queryFilters)

                            }
                            else{//No hay datos de analítica dispositivos               

                                document.getElementById(params.graphicId).className = document.getElementById(params.graphicId).className.replaceAll(" hidden", "") + " hidden"                                
                                document.getElementById("mensajeNoHayDatosGrafica"+params.graphicId).className = document.getElementById("mensajeNoHayDatosGrafica"+params.graphicId).className.replaceAll(" hidden", "")
                                
                                console.log("No se han recuperado datos de analítica.")                    
                            }

                            //Aquí controlo algunos elementos de front ya que sólo puedo hacerlo sabiendo la respuesta de la query
                            if(document.getElementById("pestañaAnalyticsPersonalizado").checked === true){
                                document.getElementById("botonDiaAnterior").className = document.getElementById("botonDiaAnterior").className.replaceAll(" invisible", "") + " invisible"    
                                document.getElementById("botonDiaSiguiente").className = document.getElementById("botonDiaSiguiente").className.replaceAll(" invisible", "") + " invisible"    
                            }
                            else{
                            
                                var numeroResultados = jsonRespuesta.body.length - 1
                                
                                try{
                                    var primerResultado = jsonRespuesta.body[0]
                                    var fechaPrimerResultado = primerResultado.DATETIME.split("T")[0]
                                    var ultimoResultado = jsonRespuesta.body[numeroResultados]
                                    var fechaUltimoResultado = ultimoResultado.DATETIME.split("T")[0]

                                    var fechaDesdeActual = document.getElementById('fechaDesde').value                                    

                                    var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
                                    var fechaActual = (new Date(Date.now() - tzoffset)).toISOString().split("T")[0];                              

                                    if( (numeroResultados === 0) && (document.getElementById("pestañaAnalyticsDia").checked === true) ){
                                        //Si estoy en el caso del día y la consulta me lleva a un día sin resultados
                                        //Se le muestra la pantalla de no hay resultados por defecto
                                        //Le deshabilito el botón adelante
                                        document.getElementById("botonDiaSiguiente").className = document.getElementById("botonDiaSiguiente").className.replaceAll(" invisible", "") + " invisible"
                                        //Le habilito el botón atrás
                                        document.getElementById("botonDiaAnterior").className = document.getElementById("botonDiaAnterior").className.replaceAll(" invisible", "")
                                    }

                                    else{ //Si tengo resultados

                                        if(fechaDesdeActual === fechaPrimerResultado){ 
                                            document.getElementById("botonDiaAnterior").className = document.getElementById("botonDiaAnterior").className.replaceAll(" invisible", "")
                                        }
                                        else{
                                            document.getElementById("botonDiaAnterior").className = document.getElementById("botonDiaAnterior").className.replaceAll(" invisible", "") + " invisible"
                                        }

                                        if(fechaActual === fechaUltimoResultado){
                                            document.getElementById("botonDiaSiguiente").className = document.getElementById("botonDiaSiguiente").className.replaceAll(" invisible", "") + " invisible"    
                                        }
                                        else{
                                            document.getElementById("botonDiaSiguiente").className = document.getElementById("botonDiaSiguiente").className.replaceAll(" invisible", "") 
                                        }
                                    
                                    }                                    

                                }
                                catch(error){
                                    console.log(error)
                                }
                            }

                        }              

                        if(document.getElementById("loader"+params.graphicId) !== null){
                            document.getElementById("loader"+params.graphicId).className = "loader contextual hidden"  
                        }  
                        
                        console.log("Datos de la gráfica cargados correctamente.")
                    }

                }
            
                else if (this.readyState === 4 && this.status !== 200) {      
                    initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
                }
                }
                xhttp.send(data);     
        }
            
    }

    function obtenerLiteralGrupo(key){

        var nombreGrupo = ""
        var jsonObjDashboard = JSON.parse(localStorage.getItem("lastDashboardData"))
        var objTemp = ""
        var keysResultados = Object.keys(jsonObjDashboard)   

        for(var x=0; x < keysResultados.length; x++){
            
            objTemp = JSON.stringify(jsonObjDashboard[keysResultados[x]])

            if(objTemp.includes(key)){
                nombreGrupo = initialConfigCommonJS.obtenerLiteralAtributo(keysResultados[x])                
                break
            }

        }

        return nombreGrupo
    }

    function procesarDatosGrafica(objResultadosQuery){

        var objResultados = objResultadosQuery
        var datosRespuesta = []            

        if ( (objResultados.length > 0) && (typeof objResultados !== 'undefined') ){    

            if(Object.keys(objResultados[0]).length > 0){

                //Obtengo las keys de los ejes
                var keysResultados = Object.keys(objResultados[0])      
                var keysOrdenadas = []
                
                //Muevo el DATETIME al primer elemento independientemente de cómo me llegue                
                for(var n=0; n < keysResultados.length; n++){                                        
                    if(keysResultados[n] === "DATETIME"){ keysOrdenadas.unshift(keysResultados[n]) }
                    else{ keysOrdenadas.push(obtenerLiteralGrupo(keysResultados[n])+" - "+initialConfigCommonJS.obtenerLiteralAtributo(keysResultados[n])) }                       
                }

                datosRespuesta.push(keysOrdenadas)

                etiquetas = keysOrdenadas
                
                //Ahora agrego los datos
                var valorTemp = []
                var fecha = ""
                var hora = ""
                var fechaHora = ""
                var keyTemp = ""
                var unidadAtributo = ""                

                for(var x=0; x < objResultados.length; x++){ //Todos los resultados          
                
                    valorTemp = []       
                    keyTemp = ""
                
                    for(var y=0; y < keysResultados.length; y++){ //Keys de cada resultado                              

                        unidadAtributo = analyticsCommonJS.obtenerUnidadAtributo(keysResultados[y])

                        if(keysResultados[y] === "DATETIME"){
                            fecha = objResultados[x][keysResultados[y]].split("T")[0]
                            fecha = fecha.split("-")
                            hora = objResultados[x][keysResultados[y]].split("T")[1]
                            hora = hora.split(":")
                            
                            if(document.getElementById("fechaDesde").value !== document.getElementById("fechaHasta").value){
                                fechaHora = fecha[2] + " " + dashbardCommonJS.obtenerNombreMes(parseInt(fecha[1])).substring(0,3) + "\n" + hora[0] + ":" + hora[1]
                            }
                            else{
                                fechaHora = hora[0] + ":" + hora[1]
                            }

                            valorTemp.unshift(fechaHora)
                        }
                        else{

                            if((keysResultados[y]==="TotalBulkConsumption")){
                                keyTemp = {v: parseFloat(objResultados[x][keysResultados[y]].replace(/\./g, "")), f: objResultados[x][keysResultados[y]] + " " + unidadAtributo} 
                            }
                            else if(                             
                            (keysResultados[y]==="WorkingTimeAccumulatedFromDate") || 
                            (keysResultados[y]==="BatteryVoltage") || 
                            (keysResultados[y]==="BatteryAmperage") || 
                            (keysResultados[y]==="CurrentGeneratorTankLevel") ||
                            (keysResultados[y]==="CurrentGeneratorTankPercentage") ||                            
                            (keysResultados[y]==="CurrentGeneratorConsumptionCost") ||                            
                            (keysResultados[y]==="CurrentGeneratorLitersConsumption") ||                            
                            (keysResultados[y]==="TodayEnergeticUse") ||                                                        
                            (keysResultados[y]==="TodayenergyWaste") ||
                            (keysResultados[y]==="TodayusedEnergyCost") ||
                            (keysResultados[y]==="TodayenergyRevenue") ||
                            (keysResultados[y]==="TodaysavingsBalance") ||
                            (keysResultados[y]==="TodayGivenAwayMoney") ||                            
                            (keysResultados[y]==="CurrentMonthEnergeticUse") ||                                                        
                            (keysResultados[y]==="CurrentMonthenergyWaste") ||
                            (keysResultados[y]==="CurrentMonthusedEnergyCost") ||
                            (keysResultados[y]==="CurrentMonthenergyRevenue") ||
                            (keysResultados[y]==="CurrentMonthsavingsBalance") ||
                            (keysResultados[y]==="CurrentMonthGivenAwayMoney") ||                            
                            (keysResultados[y]==="YearEnergeticUse") ||                                                        
                            (keysResultados[y]==="YearenergyWaste") ||
                            (keysResultados[y]==="YearusedEnergyCost") ||
                            (keysResultados[y]==="YearenergyRevenue") ||
                            (keysResultados[y]==="YearsavingsBalance") ||                           
                            (keysResultados[y]==="SinceRegistrationEnergeticUse") ||                                                        
                            (keysResultados[y]==="SinceRegistrationenergyWaste") ||
                            (keysResultados[y]==="SinceRegistrationusedEnergyCost") ||
                            (keysResultados[y]==="SinceRegistrationenergyRevenue") ||
                            (keysResultados[y]==="SinceRegistrationsavingsBalance")  ||                          
                            (keysResultados[y]==="TodayPowerExcessesPenalty") ||
                            (keysResultados[y]==="TodayReactivePenaltyAmount") ||
                            (keysResultados[y]==="CurrentMonthPowerExcessesPenalty") ||
                            (keysResultados[y]==="CurrentMonthReactivePenaltyAmount") ||
                            (keysResultados[y]==="YearPowerExcessesPenalty") ||
                            (keysResultados[y]==="YearReactivePenaltyAmount") ||
                            (keysResultados[y]==="SinceRegistrationPowerExcessesPenalty") ||
                            (keysResultados[y]==="SinceRegistrationReactivePenaltyAmount") ||
                            (keysResultados[y]==="EnergyBuyPrice") ||                            
                            (keysResultados[y]==="MarketAverageBuyPrice") ||   
                            (keysResultados[y]==="DailyEnergySellPrice") ||                            
                            (keysResultados[y]==="EnergySellPrice") ||   
                            (keysResultados[y]==="DailyAverageBuyPrice") ||                            
                            (keysResultados[y]==="DailyAverageSellPrice") ||                            
                            (keysResultados[y]==="TodayselfConsumptionBalance") ||
                            (keysResultados[y]==="CurrentMonthselfConsumptionBalance") ||
                            (keysResultados[y]==="YearselfConsumptionBalance") ||
                            (keysResultados[y]==="SinceRegistrationselfConsumptionBalance") ||
                            (keysResultados[y]==="CurrentSolarWalletBalance") ||
                            (keysResultados[y]==="PreviousMonthsSolarWalletBalance")                            
                            ){                         
                                keyTemp = {v: parseFloat(parseFloat(objResultados[x][keysResultados[y]]).toFixed(2)), f: new Intl.NumberFormat('en-DE').format(parseFloat(objResultados[x][keysResultados[y]]).toFixed(2)) + " " + unidadAtributo}
                            }
                            else if( (keysResultados[y]==="TodayTotalGeneration") || 
                                     (keysResultados[y]==="TodayTotalReactive") || 
                                     (keysResultados[y]==="Todayconsumption") || 
                                     (keysResultados[y]==="TodayfromGrid") || 
                                     (keysResultados[y]==="TodaytoGrid") || 
                                     (keysResultados[y]==="CurrentMonthTotalGeneration") || 
                                     (keysResultados[y]==="CurrentMonthTotalReactive") || 
                                     (keysResultados[y]==="CurrentMonthconsumption") || 
                                     (keysResultados[y]==="CurrentMonthfromGrid") || 
                                     (keysResultados[y]==="CurrentMonthtoGrid") || 
                                     (keysResultados[y]==="YearTotalGeneration") || 
                                     (keysResultados[y]==="YearTotalReactive") || 
                                     (keysResultados[y]==="Yearconsumption") || 
                                     (keysResultados[y]==="YearfromGrid") || 
                                     (keysResultados[y]==="YeartoGrid") ||  
                                     (keysResultados[y]==="SinceRegistrationTotalGeneration") || 
                                     (keysResultados[y]==="SinceRegistrationTotalReactive") || 
                                     (keysResultados[y]==="SinceRegistrationconsumption") || 
                                     (keysResultados[y]==="SinceRegistrationfromGrid") || 
                                     (keysResultados[y]==="SinceRegistrationtoGrid") ){

                                        keyTemp = {v: parseFloat(objResultados[x][keysResultados[y]].split(".")[0]), f: parseInt(objResultados[x][keysResultados[y]].split(".")[0]).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }).split(",")[0] + " " + unidadAtributo}                                 
                            }
                            else{                                                    
                                if( (unidadAtributo === "%") || (unidadAtributo === "W/m²") || (unidadAtributo === "L/m²") ){
                                    keyTemp = {v: parseFloat(objResultados[x][keysResultados[y]].split(".")[0]), f: new Intl.NumberFormat('en-DE').format(objResultados[x][keysResultados[y]].split(".")[0]) + " " + unidadAtributo}                                 
                                }
                                else{
                                    keyTemp = {v: parseFloat(objResultados[x][keysResultados[y]].replace(".", "")), f: objResultados[x][keysResultados[y]] + " " + unidadAtributo}                                 
                                }
                                
                            }

                            if(keysResultados[y]!=="Temperature"){

                                if(parseFloat(keyTemp.v) < 0){
                                    keyTemp.v = keyTemp.v * -1
                                    keyTemp.f = keyTemp.f.replaceAll("-","")
                                }
                            }                            

                            valorTemp.push(keyTemp)
                        }
            
                    }

                    datosRespuesta.push(valorTemp)                    
                    
                }
            }

        }        

        else{ 
            
            if(params.objQueryGrafica === null){ //Estoy haciendo una consulta desde la sección de Analytics
                console.log("Consulta desde grafica")
            }
            else{
                //Inicializo la tabla vacia para evitar el mensaje de msegs "Table has no columns" durante la carga
                datosRespuesta = [["DATETIME",""],["2022-01-01T00:00:00", 0]]
            }            
            
        }

        var copiaDatos = datosRespuesta.map((x) => x);
        copiaDatos.shift()
        filas = copiaDatos

        return datosRespuesta
    }

    function obtenerEspaciadoGrafica(){

        var factorEspaciado = 0
        var valorEspaciado = 0

        try{
            if( generalCommonJS.obtenerTipoPlataforma().includes("Web")){
                if(document.getElementById("fechaDesde").value !== document.getElementById("fechaHasta").value){ // semana, mes...
                    factorEspaciado = 10
                }
                else{ // Día
                    factorEspaciado = 10
                }            
            }
            else{            
                if(document.getElementById("fechaDesde").value !== document.getElementById("fechaHasta").value){ // semana, mes...
                    factorEspaciado = 5
                }
                else{ // Día
                    factorEspaciado = 5
                }   
            }
            
            valorEspaciado = parseInt(datosProcesados.length / factorEspaciado)
        }
        catch(error){
            valorEspaciado = 1
        }

        return valorEspaciado

    }

    function obtenerAlturaEtiquetaHAxis(){

        try{        
            var altura = 0

            if(document.getElementById("fechaDesde").value !== document.getElementById("fechaHasta").value){ // semana, mes...
                altura = 40
            }
            else{ // Día
                altura = 20
            }   
        }
        catch(error){
            altura = 20
        }
        return altura
    }

    function obtenerTamañoGrafica(){
        
        var tamaño = ""

        try{
            var objCheckboxesFiltrado = document.getElementById("filtrosAnalytics").querySelectorAll("input[type='checkbox']")    

            if(objCheckboxesFiltrado.length !== 0){

                var cadenaFiltradoTemp = ""
    
                for(var x=0; x < objCheckboxesFiltrado.length; x++){        
                if(document.getElementById(objCheckboxesFiltrado[x].id) !== null){
                    if(document.getElementById(objCheckboxesFiltrado[x].id).checked === true){
                        cadenaFiltradoTemp += objCheckboxesFiltrado[x].id + "-"
                        }
                }            
                }   
            }            
            
            if( cadenaFiltradoTemp.includes("Temperature") ){ tamaño = {} }        
            else { tamaño = { min: 0.00000001 } }        
        }
        catch(error){
            tamaño = { min: 0.00000001 }
        }

        return tamaño
    }

    return (
        <>

            <div id={params.graphicId} >
            
                <Chart
                    width={'100%'}
                    height={'100%'}
                    chartType="AreaChart"                    
                    chartEvents={chartEvents}
                    chartLanguage='es'
                    data={datosProcesados} 
                    options={options} 
                />

                <ListGraphicFilters 
                    objEtiquetas={objEtiquetas}
                    backupColoresGrafica={backupColoresGrafica}
                    showHideSeries={showHideSeries}
                    chartObj={chartObj}
                    googleObj={googleObj}
                    />

            </div>


            <div id={"mensajeNoHayDatosGrafica"+params.graphicId} className="message medium empty hidden">
                <picture>
                    <source srcSet={imgNoResultsDark} media="(prefers-color-scheme: dark)"/>
                    <img src={imgNoResultsDark} alt=" "/>
                </picture>
                <h1 className="title">No hay datos para mostrar en este periodo.</h1>                
                
            </div>

        <Loader Id={"loader"+params.graphicId} Mensaje="" initialStatus="contextual"/>

        </>
    );
}

export default GoogleChartGraphics